module.exports = __webpack_public_path__ + "static/media/member_pablo.69a48340.jpg";